export default {
  computed: {
    labelClass () {
      return {
        'subtitle-1': true,
        'red--text': this.valid === false
      }
    },
    chipColor () {
      const { value, valid } = this
      if (value === null || (Array.isArray(value) && value.length === 0)) {
        return 'gray'
      }
      if (valid) {
        return 'green'
      } else {
        return 'red'
      }
    }
  },
  methods: {
    validate (value) {
      let valid = true
      let errors = []

      for (let { type: rule, value: expected } of this.validations) {
        switch (rule) {
          case 'contains':
            if (value.indexOf(expected) === -1) {
              valid = false
              errors.push(`Expected to contanin value: ${expected}`)
            }
            break
          case 'equals':
            if (value !== expected) {
              valid = false
              errors.push(`Expected value to be equal to: ${expected}`)
            }
            break
          case 'isLessThan':
            if (value >= expected) {
              valid = false
              errors.push(`Expected value to be less than: ${expected}`)
            }
            break
          case 'isLessOrEqualThan':
            if (value > expected) {
              valid = false
              errors.push(`Expected value to be less or equal than: ${expected}`)
            }
            break
          case 'isMoreThan':
            if (value <= expected) {
              valid = false
              errors.push(`Expected value to be more than: ${expected}`)
            }
            break
          case 'isMoreOrEqualThan':
            if (value < expected) {
              valid = false
              errors.push(`Expected value to be more or equal than: ${expected}`)
            }
            break
        }
      }

      return { valid, errors }
    }
  }
}
